export class CalCentralAPI {
  constructor(csrfToken) {
    this._csrfToken = csrfToken;
    this.signOut = this.signOut.bind(this);
  }

  set csrfToken(value) {
    this._csrfToken = value;
  }

  get headers() {
    return {
      "Content-Type": "application/json",
      "X-CSRF-TOKEN": this._csrfToken,
    };
  }

  get(path) {
    return fetch(path);
  }

  post(path, values) {
    return fetch(path, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(values),
    });
  }

  put(path, values) {
    return fetch(path, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(values),
    });
  }

  destroy(path) {
    return fetch(path, {
      method: "DELETE",
      headers: this.headers,
    });
  }

  async signOut(destination) {
    const res = await this.post(`/logout`);
    const data = await res.json();
    const url = destination || data.redirectURL;
    window.location.replace(url);
  }

  async toggleAxe() {
    const axeEnabled = localStorage.getItem("axe-tools") === "true";
    const nextState = axeEnabled ? "false" : "true";
    localStorage.setItem("axe-tools", nextState);
    window.location.reload();
  }

  get auths() {
    if (!this._auths) {
      this._auths = new AuthsAPI(this);
    }

    return this._auths;
  }

  get alumniProfiles() {
    if (!this._alumniProfiles) {
      this._alumniProfiles = new AlumniProfilesAPI(this);
    }

    return this._alumniProfiles;
  }
}

class AuthsAPI {
  constructor(api) {
    this.api = api;
  }

  async find(id) {
    const res = await this.api.get(`/api/user_auths/${id}`);
    const data = await res.json();
    const success = res.ok;
    return { success, data };
  }

  async create(values) {
    return await this.api.post(`/api/user_auths`, values);
  }

  async update(id, values) {
    return await this.api.put(`/api/user_auths/${id}`, values);
  }

  async destroy(id) {
    const res = await this.api.destroy(`/api/user_auths/${id}`);
    return res.ok;
  }
}

class AlumniProfilesAPI {
  constructor(api) {
    this.api = api;
  }

  async index() {
    const res = await this.api.get(`/api/alumni/alumni_profiles`);
    const data = await res.json();
    const success = res.ok;
    return { success, data };
  }
}
